import { render, staticRenderFns } from "./disabledBanner.vue?vue&type=template&id=830bf250&scoped=true"
import script from "./disabledBanner.vue?vue&type=script&lang=js"
export * from "./disabledBanner.vue?vue&type=script&lang=js"
import style0 from "./disabledBanner.vue?vue&type=style&index=0&id=830bf250&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830bf250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('830bf250')) {
      api.createRecord('830bf250', component.options)
    } else {
      api.reload('830bf250', component.options)
    }
    module.hot.accept("./disabledBanner.vue?vue&type=template&id=830bf250&scoped=true", function () {
      api.rerender('830bf250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/disabledBanner.vue"
export default component.exports